<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />
    <b-card>
      <div style="position: relative">
        <loading-overlay :loading="loading" />
        <div class="d-flex w-100 justify-content-between">
          <div>
            <b-tabs>
              <b-tab @click="setFilter('both')" active title="مشتركة" />
              <b-tab @click="setFilter('ngo')" title="خاصة بالجمعية" />
              <b-tab @click="setFilter('guest')" title="خاصة بالزوار" />
            </b-tabs>
          </div>
          <div>
            <b-button
              @click="
                $refs.faqModal.init({ type: 'both' });
                questionModal = true;
              "
              class="d-flex align-items-center"
              variant="success"
            >
              <feather-icon icon="PlusIcon" class="mr-25" />
              إضافة
            </b-button>
          </div>
        </div>
        <app-collapse v-if="faqs.length > 0" type="margin" accordion>
          <app-collapse-item
            v-for="item in faqs"
            :key="item.id"
            :title="item.question_ar"
          >
            <template #header>
              <div class="lead collapse-title">{{ item.question_ar }}</div>
              <b-dropdown variant="link" no-caret right>
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>

                <b-dropdown-item
                  @click="onEditClicked({ ...item, type: filter })"
                >
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">تعديل</span>
                </b-dropdown-item>

                <b-dropdown-item @click="onDeleteClicked(item.id)">
                  <feather-icon icon="Trash2Icon" />
                  <span class="align-middle ml-50">حذف</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
            {{ item.answer_ar }}
          </app-collapse-item>
        </app-collapse>
        <div class="text-center p-1" style="opacity: 0.8" v-else>
          <h5>
            <feather-icon class="mx-25" icon="AlertTriangleIcon" />

            لا يوجد سجلات حتى الآن
          </h5>
        </div>
      </div>
    </b-card>
    <form-modal
      static
      ref="faqModal"
      title="إضافة سؤال"
      :loading="loading || working"
      :formSchema="faqFormSchema"
      v-model="questionModal"
      @confirm="onConfirm"
    >
      <template #type="{ form }">
        <b-form-radio-group
          :options="typeOptions"
          class="my-1"
          v-model="form.type"
          @input="setType"
        >
        </b-form-radio-group>
      </template>
    </form-modal>
  </div>
</template>

<script>
import {
  BRow,
  BDropdown,
  BDropdownItem,
  BCol,
  BCard,
  BButton,
  BFormRadioGroup,
  BTab,
  BTabs,
} from "bootstrap-vue";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import { mapActions, mapGetters } from "vuex";
import FormModal from "@/components/FormModal.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BRow,
    BDropdown,
    BDropdownItem,
    BCol,
    BCard,
    BButton,
    BFormRadioGroup,
    BTab,
    BTabs,
    MinistryBreadcrumbs,
    AppCollapse,
    AppCollapseItem,
    FormModal,
    LoadingOverlay,
  },

  data() {
    return {
      questionModal: false,
      mainTitle: "الأسئلة الأكثر شيوعاً",
      filter: "both",
      typeOptions: [
        {
          text: "مشتركة",
          value: "both",
        },
        {
          text: "خاصة بالجمعية",
          value: "interior",
        },
        {
          text: "خاصة بالزوار",
          value: "exterior",
        },
      ],
      faqFormSchema: {
        type: {
          key: "type",
        },

        faq_category_id: {
          component: "FormSelect",
          key: "faq_category_id",
          attrs: {
            id: "faq-category",
            label: "التصنيف",
            ep: "v2/ministry/both/category-faqs",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name_ar,
            rules: "required",
            ref: "faqCategorySelect",
          },
        },
        question_ar: {
          component: "FormTextarea",
          key: "question_ar",
          attrs: {
            label: "السؤال",
            rules: "required",
          },
        },
        answer_ar: {
          component: "FormTextarea",
          key: "answer_ar",
          attrs: {
            label: "الإجابة",
            rules: "required",
          },
        },
      },
      breadcrumbs: [
        {
          text: "الإعدادات",
          to: "/ministry/settings",
        },
        {
          text: "الأسئلة و الأجوبة",
          active: true,
        },
      ],
    };
  },
  created() {
    this.fetchQuestions();
  },
  computed: {
    ...mapGetters("Ministry/Settings/FAQ", [
      "loading",
      "working",
      "questions",
      "ngoQuestions",
      "guestQuestions",
      "allQuestions",
    ]),
    faqs() {
      return this.filter === "both"
        ? this.allQuestions
        : this.filter === "ngo"
        ? this.ngoQuestions
        : this.guestQuestions;
    },
  },
  methods: {
    ...mapActions("Ministry/Settings/FAQ", [
      "fetchQuestions",
      "editQuestion",
      "addQuestion",
      "deleteQuestion",
    ]),
    setFilter(filter) {
      this.filter = filter;
    },
    async onConfirm(form) {
      if (form.id) {
        await this.editQuestion(form);
      } else {
        await this.addQuestion(form);
      }
      this.questionModal = false;
    },
    setType(e) {
      this.$refs.faqModal.$refs.faqCategorySelect.refreshOptions(
        `v2/ministry/${e}/category-faqs`
      );
    },
    onEditClicked(question) {
      var x = { ...question };
      delete x.faqCategory;
      x.faq_category_id = question.faqCategory.id;
      this.$refs.faqModal.init(x);
      this.questionModal = true;
    },
    onDeleteClicked(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف السؤال ؟", {
          title: "تأكيد حذف السؤال",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "جاري الحذف ...",
                icon: "Trash2Icon",
                variant: "info",
                timeout: 3000,
              },
            });
            this.deleteQuestion(id);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
